import { useCode, isDirty } from '../../state/code-store';

/**
 * VSCode-style tab strip above the editor.
 */
export function TabsBar() {
  const order = useCode((s) => s.tabOrder);
  const tabs = useCode((s) => s.tabs);
  const active = useCode((s) => s.activePath);
  const activate = useCode((s) => s.activate);
  const closeTab = useCode((s) => s.closeTab);

  if (order.length === 0) return null;

  return (
    <div className="flex h-9 shrink-0 items-stretch overflow-x-auto border-b border-border bg-surface-subdued">
      {order.map((path) => {
        const tab = tabs[path];
        const dirty = isDirty(tab);
        const sel = active === path;
        const name = path.split('/').pop() || path;
        return (
          <div
            key={path}
            role="tab"
            aria-selected={sel}
            onClick={() => activate(path)}
            className={
              'group flex shrink-0 cursor-pointer items-center gap-2 border-r border-border px-3 text-[12px] transition-colors ' +
              (sel
                ? 'bg-surface text-text'
                : 'bg-surface-subdued text-text-subdued hover:bg-surface-hovered')
            }
            title={path}
          >
            {/* File dot */}
            <span
              className={
                'h-1.5 w-1.5 rounded-full ' +
                (dirty ? 'bg-interactive' : 'bg-transparent')
              }
            />
            <span className="max-w-[180px] truncate">{name}</span>
            <button
              onClick={(e) => {
                e.stopPropagation();
                if (dirty) {
                  const ok = confirm(`Descartar alterações em ${name}?`);
                  if (!ok) return;
                }
                closeTab(path);
              }}
              className="flex h-4 w-4 items-center justify-center rounded text-icon-subdued opacity-0 transition-colors hover:bg-surface-pressed hover:text-text group-hover:opacity-100 aria-selected:opacity-100"
              aria-selected={sel}
              title="Fechar"
            >
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <path d="M18 6 6 18M6 6l12 12" />
              </svg>
            </button>
          </div>
        );
      })}
    </div>
  );
}
